export default "__VITE_ASSET__BI4tqD5G__"